import React from 'react';
import { AnnualEnrollmentProps, NewHireProps } from '../../../arc/models/arc-epi-props';
import { DividerSection } from '../../../../global/components/layout/divider-section';

interface Props {
	myNotes: string;
	specialRequests: string;
	annualEnrollmentProps: AnnualEnrollmentProps;
	editButton: JSX.Element;
	newHireProps?: NewHireProps;
}

export function AnnualEnrollmentCommentsDisplay(props: Props) {
	const { myNotes, specialRequests, annualEnrollmentProps, editButton, newHireProps } = props;

	if (!myNotes && !specialRequests) return null;

	return (
		<DividerSection sectionText={annualEnrollmentProps?.commentsHeader} secondarySectionNode={editButton}>
			<div className='rich-text'>
				{
					myNotes &&
					<>
						<h4>{newHireProps?.myNoteLabel || annualEnrollmentProps?.myNotesLabel}</h4>
						<p>{myNotes}</p>
					</>
				}
				{
					specialRequests &&
					<>
						<h4>{newHireProps?.specialRequestTitle || annualEnrollmentProps?.specialRequestsLabel}</h4>
						<h6>{newHireProps?.specialRequestDescription || annualEnrollmentProps?.specialRequestsDescription}</h6>
						<p>{specialRequests}</p>
					</>
				}
			</div>
		</DividerSection>
	);
}

AnnualEnrollmentCommentsDisplay.defaultProps = {
	newHireProps: null,
};